import { type ScannedLocation } from 'client/scanner/scanner.types'
import { LocationZone } from 'client/types'
import { ProductWithStock, Temperatures, type ProductWithAlertInfo } from 'types/model'

export const validateProducts = (destination: ScannedLocation, products: ProductWithStock[] | ProductWithAlertInfo[]) => {
  
  const temperatureZones = [
    LocationZone.Laboratory,
    LocationZone.Frozen,
    LocationZone.Refrigerated,
  ]

  const hasColdOrFrozen = products.some((p) => p.temperature === Temperatures.FROZEN || p.temperature === Temperatures.COLD)

  if (hasColdOrFrozen && !temperatureZones.includes(destination.location.zone!)) {
    throw Error(
      'No se puede almacenar un producto de temperatura en una ubicación que no sea de tipo Laboratorio, Congelado o Refrigerado.'
    )
  }

  return destination
}

export const validateDestination = (destination: ScannedLocation, storeContainer: boolean) => {
  if (destination.location.type !== 'Storage') {
    throw Error(
      'No se puede almacenar un contenedor a una ubicación que no es de almacenamiento.'
    )
  }
  if (storeContainer) {
    if (destination.location.zone !== LocationZone.Groceries) {
      throw Error(
        'No se puede almacenar un contenedor en una ubicación que no permite contenedores.'
      )
    }
    if (destination.location.classification !== 'Unit') {
      throw Error(
        'No se puede almacenar un contenedor a una ubicación de piso.'
      )
    }
    if (destination.totalContainers > 0) {
      throw Error(
        'No se puede almacenar un contenedor a una ubicación que ya tiene un contenedor.'
      )
    }
  }

  if (!storeContainer && destination.location.zone === LocationZone.Groceries) {
    throw Error(
      'No se puede almacenar productos a una ubicación que solamente permite contenedores.'
    )
  }
  return destination
}
